import { memo } from "react";
import { Link } from "react-router-dom";

const CustomerDetails = ({ customer }) => {
    const {
        customer_id,
        customer_full_name,
        customer_email,
        customer_contact_number,
        customer_profile_image
    } = customer;

    return (
        <div className="card h-100">
            <div className="card-header pb-0 p-3">
                <h6 className="text-start">Customer Details</h6>
            </div>
            <div className="card-body p-3 py-1">
                <div className="row">
                    {/* LEFT */}
                    <div className="col-lg-6 col-md-6 col-12 d-flex align-items-center">
                        <img
                            src={customer_profile_image || "/assets/img/lock_user.png"}
                            alt={`${customer_full_name}`}
                            width={90}
                            height={90}
                            className="border-radius-lg me-3 cursor-pointer"
                        />

                        <div>
                            <h6 className="text-lg mb-0 mt-2">
                                {customer_full_name}
                            </h6>

                            <p className="text-sm mb-1 font-weight-bold">{customer_contact_number}</p>
                            <p className="text-sm mb-1 font-weight-bold">{customer_email}</p>
                        </div>
                    </div>

                    {/* RIGHT */}
                    <div className="col-lg-6 col-md-6 col-12 my-auto text-end">
                        <Link to={`/customers/view/${customer_id}`} className="btn bg-gradient-dark btn-sm mb-0">
                            <i className="material-icons text-lg">list_alt</i>{" "}
                            Details
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(CustomerDetails);